var path = 'modules/dcb-eaccount.pages.eadashboard/components/largeAdvertising.tpl.html';
var html = "\n<img src=\"../assets/images/diners/ad-background-large.jpg\" alt=\"Werbung\" data-src-hd=\"../assets/images/diners/ad-background-large@2x.jpg\">\n\n<div class=\"advertisement-body\">\n    <h2 data-i18n=\"advertisement.title\">Neue Reiseangebote <small>heute entdecken</small></h2>\n</div>\n\n<footer class=\"advertisement-footer\">\n    <a href=\"\"><i class=\"icon-readmore-white\"></i></a>\n</footer>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./~/ngtemplate-loader?relativeTo=/src/ui/modules/eaDashboard/components&prefix=modules/dcb-eaccount.pages.eadashboard/components!./~/raw-loader!./src/ui/modules/eaDashboard/components/largeAdvertising.tpl.html
// module id = 896
// module chunks = 12